import React, { Component } from 'react';

import { Alert, Button, Table, Jumbotron, Pagination } from 'react-bootstrap';

import ProcessAdd from './ProcessAdd.js';
import ProcessChange from './ProcessChange.js';
import ProcessSettings from './ProcessSettings.js';

import ConfirmDeletePopup from '../Controls/ConfirmDeletePopup.js';

import './Process.css';
import '../Controls/MusterTableStyle.css';

class Process extends Component {

    confirmDeletePopup = React.createRef();

    constructor(props) {
        super(props);

        let process = {
            ProcessId: -1,
            Name: "",
            Description: "",
            Command: "",
            HiddenParam: ""
        }

        this.state = {
            list: [],
            errMsg: '',
            showAddProcess: false,
            addProcessErrMsg: '',
            renderAlert: false,
            alertMsg: '',
            alertSuccess: false,
            showUpdateProcess: false,
            processToUpdate: process,
            showProcessSettings: false,
            processForSettings: process,
            numProcesses: 0,
            pageId: 1,
            startIndex: 0,
            pageSize: parseInt((window.innerHeight - 150.0) / 80)
        };
    }

    componentDidMount() {
        /*
        fetch('process_list')
        .then(res => res.json())
        .then((data) => {
            this.setState({
                list: data
            });
        })
        .catch(console.log)
        */

        fetch('process_stats')
        .then(res => res.json())
        .then((data) => {

            this.setState({
                numProcesses: data[0].numProcesses
            });

            fetch('process_list', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
                body: "startIndex=" + this.state.startIndex + "&pageSize=" + this.state.pageSize
            })
            .then(res => res.json())
            .then((data) => {
                this.setState({ list: data });
            })
            .catch(console.log)
        })
        .catch(console.log)
    }

    reloadPage = () => {
        this.refs.mapList.reloadPage();
    }

    renderPagination = () => {
        let numPages = Math.ceil((this.state.numProcesses) / this.state.pageSize);
        let items = [];
        let active = this.state.pageId;

        var iStartPageId = active - 10;  //the number of tabs to display at the top
        var iFinishPageId = active + 10;

        if (iStartPageId < 1)
            iStartPageId = 1;

        if (iFinishPageId > numPages)
            iFinishPageId = numPages;

        /*
        console.log("renderPagination");
        console.log("numProcesses = " + this.state.numProcesses);
        console.log("pageSize = " + this.state.pageSize);
        console.log("numPages = " + numPages);
        console.log("active = " + active);
        console.log("iStartPageId = " + iStartPageId);
        console.log("iFinishPageId = " + iFinishPageId);
        */

        //for (let number = 1; number <=numPages; number++)
        for (let number = iStartPageId; number <= iFinishPageId; number++)
        {
            items.push(
                <Pagination.Item className="pageWorkflows" key={number} active={number === active}>
                {number}
                </Pagination.Item>,
            );
        }

        return (
            <Pagination onClick={this.loadPage}>{items}</Pagination>
        )
    }

    loadPage = e => {
        if (typeof e.target.text !== "undefined")
        {
            let newPageId = parseInt(e.target.text);
            let newStartIndex = (newPageId-1) * this.state.pageSize;

            this.setState({
                pageId: newPageId,
                startIndex: newStartIndex
            });

            fetch('process_list', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
                body: "startIndex=" + newStartIndex + "&pageSize=" + this.state.pageSize + "&sortFilter=" + this.state.sortFilter + "&sortOrder=" + this.state.sortOrder
            })
            .then(res => res.json())
            .then((data) => {
            this.setState({ list: data });
            })
            .catch(console.log)
        }
    }

    handleDelete = (processId) => event => {
        event.preventDefault();
        this.confirmDeletePopup.current.request(() => this.performDelete(processId));
    }

    performDelete = (processId) => {

        fetch('process_delete', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "processId=" + processId
        })
        .then(res => res.json())
        .then(data =>
        {
            if ('true' === data[0].delete)
            {
                fetch('process_list')
                .then(res => res.json())
                .then((data) => {
                    this.setState({
                        list: data
                    });
                })
                .catch(console.log);
            }
            else
            {
                this.setState({
                    renderAlert: true,
                    alertMsg: data[0].msg,
                    alertSuccess: false
                });

                setTimeout(this.hideAlert, 3000)
            }
        })
        .catch(console.log)

    }

    renderHeader = () => {
        if (1 === this.props.accessLevel)
        {
            return (
                <thead>
                    <tr>
                        <th class="pipelineAbsorbingColumn"></th>
                        <th><h3>Process</h3></th>
                        <th><h3>Name</h3></th>
                        <th><h3>Description</h3></th>
                        <th><h3>Command</h3></th>
                        <th><h3>Settings</h3></th>
                        <th></th>
                        <th class="pipelineAbsorbingColumn"></th>
                    </tr>
                </thead>
            )
        }
        else
        {
            return (
                <thead>
                    <tr>
                        <th class="pipelineAbsorbingColumn"></th>
                        <th><h3>Process</h3></th>
                        <th><h3>Name</h3></th>
                        <th><h3>Description</h3></th>
                        <th><h3>Command</h3></th>
                        <th><h3>Settings</h3></th>
                        <th class="pipelineAbsorbingColumn"></th>
                    </tr>
                </thead>
            )
        }
    }

    renderListData = () => {
        if (1 === this.props.accessLevel)
        {
            return this.state.list.map((process) => (
                <tbody>
                    <tr>
                        <td class="pipelineAbsorbingColumn"></td>
                        <td className="processList" onClick={() => this.showUpdateProcess(process)}>{process.ProcessId}</td>
                        <td className="processList" onClick={() => this.showUpdateProcess(process)}>{process.Name}</td>
                        <td className="processList" onClick={() => this.showUpdateProcess(process)}>{process.Description}</td>
                        <td className="processList" onClick={() => this.showUpdateProcess(process)}>{process.Command}</td>
                        <td className="processList processSettingsCell" onClick={() => this.showProcessSettings(process)} title="Settings">{this.renderSettingsIcon()}</td>
                        <td className="processList">
                            <form name="frmDelete" onSubmit={this.handleDelete(process.ProcessId)}>
                            <Button variant="danger" size="lg" type="submit">Delete</Button>
                            </form>
                        </td>
                        <td class="pipelineAbsorbingColumn"></td>
                    </tr>
                </tbody>
            ))
        }
        else
        {
            return this.state.list.map((process) => (
                <tbody>
                    <tr>
                        <td class="pipelineAbsorbingColumn"></td>
                        <td className="processList" onClick={() => this.showUpdateProcess(process)}>{process.ProcessId}</td>
                        <td className="processList" onClick={() => this.showUpdateProcess(process)}>{process.Name}</td>
                        <td className="processList" onClick={() => this.showUpdateProcess(process)}>{process.Description}</td>
                        <td className="processList" onClick={() => this.showUpdateProcess(process)}>{process.Command}</td>
                        <td className="processList processSettingsCell" onClick={() => this.showProcessSettings(process)} title="Settings">{this.renderSettingsIcon()}</td>
                        <td class="pipelineAbsorbingColumn"></td>
                    </tr>
                </tbody>
            ))
        }
    }

    reloadProcesses = () => {
        //console.log("reloadProcesses");
        fetch('process_list')
        .then(res => res.json())
        .then((data) => {
            this.setState({
                list: data
            });
        })
        .catch(console.log)
    }

    showAddProcess = () => {
        this.setState({
            showAddProcess: true
        });
    }

    hideAddProcess = () => {
        this.setState({
            showAddProcess: false
        });
    }

    hideAlert = () =>
    {
        this.setState({
            renderAlert: false
        });
    }

    renderAlert = () =>
    {
        if (this.state.renderAlert)
        {
            if (this.state.alertSuccess)
            {
                return (<Alert key="success" variant="success">
                            {this.state.alertMsg}
                        </Alert>);
            }
            else
            {
                return (<Alert key="danger" variant="danger">
                            {this.state.alertMsg}
                        </Alert>);
            }
        }

    }

    reloadSettings = () => {
        this.refs.categorylist.reloadList(this.state.pageId, this.state.pageSize);
    }

    hideUpdateProcess = () => {
        this.setState({
            showUpdateProcess: false,
            errMsg: ''
        });
    }

    showUpdateProcess = (process) => {
        //console.log("Show update process");
        //console.log(process);
        this.setState({
            processToUpdate: process,
            showUpdateProcess: true,
            errMsg: ''
        });
    }

    // Stored single-line "param1;param2;param3" -> multi-line for the textarea
    hiddenParamToDisplay = (hiddenParam) => {
        if (!hiddenParam)
            return '';

        return hiddenParam.replace(/;/g, ';\n');
    }

    // Multi-line textarea value -> single-line for the database
    hiddenParamToStored = (hiddenParam) => {
        if (!hiddenParam)
            return '';

        // Strip cosmetic newlines and any spaces before storing.
        return hiddenParam.replace(/[\r\n ]+/g, '');
    }

    showProcessSettings = (process) => {
        // Work on a copy so the underlying list item isn't mutated with the
        // display (multi-line) form of the parameters.
        let processForSettings = Object.assign({}, process);
        processForSettings.HiddenParam = this.hiddenParamToDisplay(process.HiddenParam);

        this.setState({
            processForSettings: processForSettings,
            showProcessSettings: true
        });
    }

    hideProcessSettings = () => {
        this.setState({
            showProcessSettings: false
        });
    }

    handleUpdateHiddenParam = (e) => {
        let process = this.state.processForSettings;
        process.HiddenParam = e.target.value;
        this.setState({
            processForSettings: process
        });
    }

    handleSaveProcessSettings = () => {
        let process = this.state.processForSettings;

        // Strip the cosmetic newlines so the database stores a single line.
        let hiddenParam = this.hiddenParamToStored(process.HiddenParam);

        fetch('process_settings_update', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "ProcessId=" + process.ProcessId + "&HiddenParam=" + encodeURIComponent(hiddenParam)
        })
        .then(res => res.json())
        .then(data => {
            this.setState({
                showProcessSettings: false
            });

            this.reloadProcesses();
        })
        .catch(console.log)
    }

    renderSettingsIcon = () => {
        return (
            <svg className="processSettingsIcon" width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M19.14,12.94c0.04-0.3,0.06-0.61,0.06-0.94c0-0.32-0.02-0.64-0.07-0.94l2.03-1.58c0.18-0.14,0.23-0.41,0.12-0.61l-1.92-3.32c-0.12-0.22-0.37-0.29-0.59-0.22l-2.39,0.96c-0.5-0.38-1.03-0.7-1.62-0.94L14.4,2.81c-0.04-0.24-0.24-0.41-0.48-0.41h-3.84c-0.24,0-0.43,0.17-0.47,0.41L9.25,5.35C8.66,5.59,8.12,5.92,7.63,6.29L5.24,5.33c-0.22-0.08-0.47,0-0.59,0.22L2.74,8.87C2.62,9.08,2.66,9.34,2.86,9.48l2.03,1.58C4.84,11.36,4.8,11.69,4.8,12s0.02,0.64,0.07,0.94l-2.03,1.58c-0.18,0.14-0.23,0.41-0.12,0.61l1.92,3.32c0.12,0.22,0.37,0.29,0.59,0.22l2.39-0.96c0.5,0.38,1.03,0.7,1.62,0.94l0.36,2.54c0.05,0.24,0.24,0.41,0.48,0.41h3.84c0.24,0,0.44-0.17,0.47-0.41l0.36-2.54c0.59-0.24,1.13-0.56,1.62-0.94l2.39,0.96c0.22,0.08,0.47,0,0.59-0.22l1.92-3.32c0.12-0.22,0.07-0.47-0.12-0.61L19.14,12.94z M12,15.6c-1.98,0-3.6-1.62-3.6-3.6s1.62-3.6,3.6-3.6s3.6,1.62,3.6,3.6S13.98,15.6,12,15.6z"/>
            </svg>
        );
    }

    handleUpdateName = (e) => {
        let process = this.state.processToUpdate;
        process.Name = e.target.value;
        this.setState({
            processToUpdate: process
        });
    }

    handleUpdateDescription = (e) => {
        let process = this.state.processToUpdate;
        process.Description = e.target.value;
        this.setState({
            processToUpdate: process
        });
    }

    handleUpdateCommand = (e) => {
        let process = this.state.processToUpdate;
        process.Command = e.target.value;
        this.setState({
            processToUpdate: process
        });
    }

    handleUpdateProcess = () => {
        let process = this.state.processToUpdate;

        console.log("updateProcess");
        console.log(process);

        this.setState({
            processToUpdate: process
        });

        fetch('process_update', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "ProcessId=" + process.ProcessId + "&Name=" + process.Name + "&Description=" + process.Description + "&Command=" + process.Command
        })
        .then(res => res.json())
        .then(data =>
        {
            if ('true' === data[0].update)
            {
                this.setState({
                    errMsg: data[0].msg,
                    showUpdateProcess: false
                });
            }
            else
            {
                this.setState({
                    errMsg: data[0].msg,
                    showUpdateProcess: false
                });
            }

            this.reloadProcesses();
        })
    }

    render() {
        if (1 === this.props.accessLevel)
        {
            return (<div>
                    <ProcessChange
                    showUpdateProcess={this.state.showUpdateProcess}
                    hideUpdateProcess={this.hideUpdateProcess}
                    handleUpdateProcess={this.handleUpdateProcess}
                    handleUpdateName={this.handleUpdateName}
                    handleUpdateDescription={this.handleUpdateDescription}
                    handleUpdateCommand={this.handleUpdateCommand}
                    process={this.state.processToUpdate}>
                    </ProcessChange>

                    <ProcessSettings
                    showProcessSettings={this.state.showProcessSettings}
                    hideProcessSettings={this.hideProcessSettings}
                    handleSaveProcessSettings={this.handleSaveProcessSettings}
                    handleUpdateHiddenParam={this.handleUpdateHiddenParam}
                    process={this.state.processForSettings}>
                    </ProcessSettings>

                    <ProcessAdd hideAddProcess={this.hideAddProcess} showAddProcess={this.state.showAddProcess} reloadProcesses={this.reloadProcesses}></ProcessAdd>

                    <Jumbotron className="jumboHeader">
                    <center><h1 class="process-title">Process</h1></center>
                    <div><Button className="btnAddProcess" size="lg" onClick={this.showAddProcess}>Add Process</Button></div>
                    <div class="paginationProcess">{this.renderPagination()}</div>
                    </Jumbotron>
                    <Table className="pipelineList musterStyleTable">
                    {this.renderHeader()}
                    {this.renderListData()}
                    </Table>
                    {this.renderAlert()}
                    <ConfirmDeletePopup ref={this.confirmDeletePopup} />

                    </div>)
        }
        else
        {
            return (<div>
                    <ProcessChange
                    showUpdateProcess={this.state.showUpdateProcess}
                    hideUpdateProcess={this.hideUpdateProcess}
                    handleUpdateProcess={this.handleUpdateProcess}
                    handleUpdateName={this.handleUpdateName}
                    handleUpdateDescription={this.handleUpdateDescription}
                    handleUpdateCommand={this.handleUpdateCommand}
                    process={this.state.processToUpdate}>
                    </ProcessChange>

                    <ProcessSettings
                    showProcessSettings={this.state.showProcessSettings}
                    hideProcessSettings={this.hideProcessSettings}
                    handleSaveProcessSettings={this.handleSaveProcessSettings}
                    handleUpdateHiddenParam={this.handleUpdateHiddenParam}
                    process={this.state.processForSettings}>
                    </ProcessSettings>

                    <ProcessAdd hideAddProcess={this.hideAddProcess} showAddProcess={this.state.showAddProcess} reloadProcesses={this.reloadProcesses}></ProcessAdd>

                    <Jumbotron className="jumboHeader">
                    <center><h1 class="process-title">Process</h1></center>
                    <div></div>
                    <div class="paginationProcess">{this.renderPagination()}</div>
                    </Jumbotron>
                    <Table className="pipelineList musterStyleTable">
                    {this.renderHeader()}
                    {this.renderListData()}
                    </Table>
                    {this.renderAlert()}
                    <ConfirmDeletePopup ref={this.confirmDeletePopup} />

                    </div>)
        }

    }
}

export default Process;
